import { Typography } from '@components/typography';
import { Box, Collapse } from '@mui/material';
import { useState } from 'react';

/**
 * Collapsible section for agent thinking/reasoning blocks.
 * Shown dimmed and italic to be visually distinct from the main answer.
 */
export const AgentChatThinkingBlock = ({ content }: { content: string }) => {
  const [open, setOpen] = useState(false);

  return (
    <Box>
      <Typography
        role="button"
        variant="caption1"
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          cursor: 'pointer',
          color: 'agentChat.message.agent.foreground.light',
          borderRadius: 0.75,
          '&:hover': {
            backgroundColor: 'agentChat.message.agent.backgroundHover',
            color: 'agentChat.message.agent.foreground.default',
          },
          px: 1,
          py: 0.5,
        }}
        data-testid="agent-chat-thinking-toggle"
      >
        {open ? 'Hide thinking' : 'Show thinking'}
      </Typography>
      <Collapse in={open}>
        <Typography
          variant="caption2"
          sx={{
            color: 'agentChat.message.agent.foreground.light',
            fontStyle: 'italic',
            whiteSpace: 'pre-wrap',
            mt: 0.5,
          }}
        >
          {content}
        </Typography>
      </Collapse>
    </Box>
  );
};
